import React from 'react';
import CheckMark from '../../icons/checkMark.svg';
import {Wrapper, SingleFeature} from './styles';

const content = [
  {text: 'سوف تحصل على فترة تجريبية', specialText: 'لمدة أسبوع فور اشتراكك'},
  {
    text: 'لن يتم خصم مبلغ الاشتراك',
    specialText: 'الا بعد انتهاء الفترة التجريبية',
  },
  {
    text: 'يمكنك الغاء اشتراكك ',
    specialText: 'في أي وقت',
  },
];
const SubscriptionDescription = () => (
  <Wrapper>
    {content.map((content, i) => (
      <SingleFeature key={i} index={i}>
        <img src={CheckMark} alt="check icon" />
        <p>
          {content.text} <span>{content.specialText}</span>
        </p>
      </SingleFeature>
    ))}
  </Wrapper>
);

export default SubscriptionDescription;
